// Generated by Melange

import * as Buhta_cabinet__AdminDashboardHeader from "../../components/molecules/AdminDashboardHeader.js";
import * as Buhta_cabinet__AdminDashboardHeaderMobile from "../../components/molecules/AdminDashboardHeaderMobile.js";
import * as Buhta_cabinet__AdminSidebar from "../../components/molecules/AdminSidebar/AdminSidebar.js";
import * as Buhta_cabinet__AdminSidebarIdentity from "../../components/molecules/AdminSidebar/AdminSidebarIdentity.js";
import * as Buhta_cabinet__AdminSidebarMobile from "../../components/molecules/AdminSidebar/AdminSidebarMobile.js";
import * as Buhta_cabinet__ControlAdmin from "../../grpc/ControlAdmin.js";
import * as Buhta_cabinet__CredentialCreate from "../../components/organisms/Admin/Credentials/CredentialCreate.js";
import * as Buhta_cabinet__CredentialEdit from "../../components/organisms/Admin/Credentials/CredentialEdit.js";
import * as Buhta_cabinet__CredentialItem from "../../components/organisms/Admin/Credentials/CredentialItem.js";
import * as Buhta_cabinet__CredentialsPage from "../Admin/Keychain/CredentialsPage.js";
import * as Buhta_cabinet__HelpCenter from "../Admin/HelpCenter/HelpCenter.js";
import * as Buhta_cabinet__HelpChatPage from "../Admin/HelpCenter/HelpChatPage.js";
import * as Buhta_cabinet__HelpNewTicketPage from "../Admin/HelpCenter/HelpNewTicketPage.js";
import * as Buhta_cabinet__IdentitiesPage from "../Admin/Identities/IdentitiesPage.js";
import * as Buhta_cabinet__Identity from "../../models/Identity.js";
import * as Buhta_cabinet__IdentityCreatePage from "../Admin/Identities/IdentityCreatePage.js";
import * as Buhta_cabinet__IdentityViewPage from "../Admin/Identities/IdentityViewPage.js";
import * as Buhta_cabinet__KeyCreate from "../../components/organisms/Admin/Keychain/KeyCreate.js";
import * as Buhta_cabinet__KeyEdit from "../../components/organisms/Admin/Keychain/KeyEdit.js";
import * as Buhta_cabinet__KeyItem from "../../components/organisms/Admin/Keychain/KeyItem.js";
import * as Buhta_cabinet__KeysPage from "../Admin/Keychain/KeysPage.js";
import * as Buhta_cabinet__Link from "../../components/html/Link.js";
import * as Buhta_cabinet__MainPage from "../../components/organisms/Main/MainPage.js";
import * as Buhta_cabinet__OrgCreatePage from "../Admin/OrgCreatePage.js";
import * as Buhta_cabinet__OrgViewPage from "../Admin/OrgViewPage.js";
import * as Buhta_cabinet__OrgsPage from "../Admin/OrgsPage.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__GrpcState from "../../../../../packages/core/lib/GrpcState.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(title) {
  return function (children) {
    return function (rightChildrenOpt) {
      const rightChildren = rightChildrenOpt !== undefined ? Caml_option.valFromOption(rightChildrenOpt) : null;
      return function (openMenu) {
        return function (arrowBackOpt) {
          const arrowBack = arrowBackOpt !== undefined ? arrowBackOpt : false;
          return function (routeOpt) {
            const route = routeOpt !== undefined ? routeOpt : ({
                  TAG: /* Admin */7,
                  _0: /* Main */0
                });
            const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
            const deviceType = state.deviceType;
            return JsxRuntime.jsxs("div", {
                        children: [
                          deviceType === "mobile" ? JsxRuntime.jsx(Buhta_cabinet__AdminDashboardHeaderMobile.make, {
                                  title: title,
                                  openMenu: openMenu,
                                  rightChildren: rightChildren
                                }) : JsxRuntime.jsx(Buhta_cabinet__AdminDashboardHeader.make, {
                                  className: "shrink-0",
                                  title: title,
                                  route: route,
                                  rightChildren: rightChildren,
                                  arrowBack: arrowBack
                                }),
                          children
                        ],
                        className: "flex-1 flex flex-col items-stretch overflow-auto focus:outline-none",
                        tabIndex: 0,
                        onScroll: (function (param) {
                            
                          })
                      });
          };
        };
      };
    };
  };
}

function AdminDashboardPage$DashboardContentWrapper(Props) {
  return Curry._4(make(Props.title)(Props.children), Props.rightChildren, Props.openMenu, Props.arrowBack, Props.route);
}

const DashboardContentWrapper = {
  make: AdminDashboardPage$DashboardContentWrapper
};

function AdminDashboardPage$NewOrg(Props) {
  return JsxRuntime.jsxs(Buhta_cabinet__Link.make, {
              route: {
                TAG: /* Admin */7,
                _0: {
                  TAG: /* Orgs */1,
                  _0: /* Create */1
                }
              },
              className: "bg-links flex rounded px-3 py-2 hover:bg-links-hover active:bg-links-active",
              children: [
                JsxRuntime.jsx("img", {
                      className: "w-4 h-4",
                      src: StaticAsset.src("/static/icons/plus.svg")
                    }),
                JsxRuntime.jsx(Buhta_components__Text.H6.make, {
                      className: "ml-1 text-white",
                      children: "Новое предприятие"
                    })
              ]
            });
}

const NewOrg = {
  make: AdminDashboardPage$NewOrg
};

function AdminDashboardPage$NewIdentity(Props) {
  return JsxRuntime.jsxs(Buhta_cabinet__Link.make, {
              route: {
                TAG: /* Admin */7,
                _0: {
                  TAG: /* Identities */2,
                  _0: /* Create */1
                }
              },
              className: "bg-links flex rounded px-3 py-2 hover:bg-links-hover active:bg-links-active",
              children: [
                JsxRuntime.jsx("img", {
                      className: "w-4 h-4",
                      src: StaticAsset.src("/static/icons/plus.svg")
                    }),
                JsxRuntime.jsx(Buhta_components__Text.H6.make, {
                      className: "ml-1 text-white",
                      children: "Новый пользователь"
                    })
              ]
            });
}

const NewIdentity = {
  make: AdminDashboardPage$NewIdentity
};

function AdminDashboardPage$NewKey(Props) {
  return JsxRuntime.jsxs(Buhta_cabinet__Link.make, {
              route: {
                TAG: /* Admin */7,
                _0: {
                  TAG: /* Keychain */0,
                  _0: {
                    TAG: /* Keys */0,
                    _0: /* Create */1
                  }
                }
              },
              className: "bg-links flex rounded px-3 py-2 hover:bg-links-hover active:bg-links-active",
              children: [
                JsxRuntime.jsx("img", {
                      className: "w-4 h-4",
                      src: StaticAsset.src("/static/icons/plus.svg")
                    }),
                JsxRuntime.jsx(Buhta_components__Text.H6.make, {
                      className: "ml-1 text-white",
                      children: "Создать ключ"
                    })
              ]
            });
}

const NewKey = {
  make: AdminDashboardPage$NewKey
};

function AdminDashboardPage(Props) {
  let route = Props.route;
  const currentRoute = Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined));
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const match = React.useState(function () {
        return false;
      });
  const setMobileMenuOpen = match[1];
  const mobileMenuOpen = match[0];
  let identityId;
  if (typeof currentRoute === "number" || currentRoute.TAG !== /* Admin */7) {
    identityId = "";
  } else {
    const match$1 = currentRoute._0;
    if (typeof match$1 === "number" || match$1.TAG !== /* Identities */2) {
      identityId = "";
    } else {
      const match$2 = match$1._0;
      identityId = typeof match$2 === "number" ? "" : match$2._0;
    }
  }
  const func = Buhta_cabinet__ControlAdmin.AdminIdentityService.view;
  const match$3 = Buhta_core__GrpcState.useModel((function (param) {
          return Curry._3(func, param, /* [] */0, identityId);
        }), undefined);
  const dispatch = match$3[1];
  React.useEffect((function () {
          if (identityId !== "") {
            Curry._2(dispatch, undefined, undefined);
          }
          
        }), [identityId]);
  const openMenu = function (param) {
    Curry._1(setMobileMenuOpen, (function (param) {
            return true;
          }));
  };
  let tmp;
  let exit = 0;
  if (typeof route === "number") {
    exit = 1;
  } else {
    switch (route.TAG | 0) {
      case /* Orgs */1 :
          if (typeof route._0 === "number") {
            exit = 1;
          } else {
            tmp = null;
          }
          break;
      case /* Identities */2 :
          if (typeof route._0 === "number") {
            exit = 1;
          } else {
            tmp = deviceType === "mobile" ? JsxRuntime.jsx(Buhta_cabinet__AdminSidebarMobile.make, {
                    isOpen: mobileMenuOpen,
                    onClose: (function (param) {
                        Curry._1(setMobileMenuOpen, (function (param) {
                                return false;
                              }));
                      })
                  }) : JsxRuntime.jsx(Buhta_cabinet__AdminSidebarIdentity.make, {});
          }
          break;
      default:
        exit = 1;
    }
  }
  if (exit === 1) {
    tmp = deviceType === "mobile" ? JsxRuntime.jsx(Buhta_cabinet__AdminSidebarMobile.make, {
            isOpen: mobileMenuOpen,
            onClose: (function (param) {
                Curry._1(setMobileMenuOpen, (function (param) {
                        return false;
                      }));
              })
          }) : JsxRuntime.jsx(Buhta_cabinet__AdminSidebar.make, {});
  }
  let tmp$1;
  if (typeof route === "number") {
    tmp$1 = JsxRuntime.jsx(AdminDashboardPage$DashboardContentWrapper, {
          title: "Главная",
          children: JsxRuntime.jsx(Buhta_cabinet__MainPage.make, {}),
          openMenu: openMenu
        });
  } else {
    switch (route.TAG | 0) {
      case /* Keychain */0 :
          const tab = route._0;
          if (tab.TAG === /* Keys */0) {
            const id = tab._0;
            tmp$1 = typeof id === "number" ? (
                id === /* List */0 ? JsxRuntime.jsx(AdminDashboardPage$DashboardContentWrapper, {
                        title: "Ключи",
                        children: JsxRuntime.jsx(Buhta_cabinet__KeysPage.make, {}),
                        rightChildren: JsxRuntime.jsx(AdminDashboardPage$NewKey, {}),
                        openMenu: openMenu
                      }) : JsxRuntime.jsx(AdminDashboardPage$DashboardContentWrapper, {
                        title: "Новый ключ",
                        children: JsxRuntime.jsx(Buhta_cabinet__KeyCreate.make, {}),
                        openMenu: openMenu
                      })
              ) : (
                id.TAG === /* View */0 ? JsxRuntime.jsx(AdminDashboardPage$DashboardContentWrapper, {
                        title: "Детали ключа",
                        children: JsxRuntime.jsx(Buhta_cabinet__KeyItem.make, {
                              id: id._0
                            }),
                        openMenu: openMenu
                      }) : JsxRuntime.jsx(AdminDashboardPage$DashboardContentWrapper, {
                        title: "Редактирования ключа",
                        children: JsxRuntime.jsx(Buhta_cabinet__KeyEdit.make, {
                              id: id._0
                            }),
                        openMenu: openMenu
                      })
              );
          } else {
            const id$1 = tab._0;
            tmp$1 = typeof id$1 === "number" ? (
                id$1 === /* List */0 ? JsxRuntime.jsx(AdminDashboardPage$DashboardContentWrapper, {
                        title: "Ключи",
                        children: JsxRuntime.jsx(Buhta_cabinet__CredentialsPage.make, {}),
                        openMenu: openMenu
                      }) : JsxRuntime.jsx(AdminDashboardPage$DashboardContentWrapper, {
                        title: "Ключи",
                        children: JsxRuntime.jsx(Buhta_cabinet__CredentialCreate.make, {}),
                        openMenu: openMenu
                      })
              ) : (
                id$1.TAG === /* View */0 ? JsxRuntime.jsx(AdminDashboardPage$DashboardContentWrapper, {
                        title: "Ключи",
                        children: JsxRuntime.jsx(Buhta_cabinet__CredentialItem.make, {
                              id: id$1._0
                            }),
                        openMenu: openMenu
                      }) : JsxRuntime.jsx(AdminDashboardPage$DashboardContentWrapper, {
                        title: "Ключи",
                        children: JsxRuntime.jsx(Buhta_cabinet__CredentialEdit.make, {
                              id: id$1._0
                            }),
                        openMenu: openMenu
                      })
              );
          }
          break;
      case /* Orgs */1 :
          const state$1 = route._0;
          if (typeof state$1 === "number") {
            let exit$1 = 0;
            if (typeof state$1 === "number" && state$1) {
              tmp$1 = JsxRuntime.jsx(AdminDashboardPage$DashboardContentWrapper, {
                    title: "Новое предприятие",
                    children: JsxRuntime.jsx(Buhta_cabinet__OrgCreatePage.make, {
                          onClose: (function (param) {
                              Buhta_cabinet__Route.navigateTo({
                                    TAG: /* Admin */7,
                                    _0: {
                                      TAG: /* Orgs */1,
                                      _0: /* List */0
                                    }
                                  });
                            }),
                          onItemCreated: (function (id) {
                              Buhta_cabinet__Route.navigateTo({
                                    TAG: /* Admin */7,
                                    _0: {
                                      TAG: /* Orgs */1,
                                      _0: /* Org */{
                                        _0: id,
                                        _1: /* Dashboard */0
                                      }
                                    }
                                  });
                            })
                        }),
                    openMenu: openMenu,
                    arrowBack: true,
                    route: {
                      TAG: /* Admin */7,
                      _0: {
                        TAG: /* Orgs */1,
                        _0: /* List */0
                      }
                    }
                  });
            } else {
              exit$1 = 1;
            }
            if (exit$1 === 1) {
              tmp$1 = JsxRuntime.jsx(AdminDashboardPage$DashboardContentWrapper, {
                    title: "Предприятия",
                    children: JsxRuntime.jsx(Buhta_cabinet__OrgsPage.make, {}),
                    rightChildren: JsxRuntime.jsx(AdminDashboardPage$NewOrg, {}),
                    openMenu: openMenu
                  });
            }
            
          } else {
            tmp$1 = JsxRuntime.jsx(Buhta_cabinet__OrgViewPage.make, {
                  id: state$1._0,
                  route: state$1._1
                });
          }
          break;
      case /* Identities */2 :
          const match$4 = route._0;
          tmp$1 = typeof match$4 === "number" ? (
              match$4 ? JsxRuntime.jsx(AdminDashboardPage$DashboardContentWrapper, {
                      title: "Новый пользователь",
                      children: JsxRuntime.jsx(Buhta_cabinet__IdentityCreatePage.make, {
                            onClose: (function (param) {
                                Buhta_cabinet__Route.navigateTo({
                                      TAG: /* Admin */7,
                                      _0: {
                                        TAG: /* Identities */2,
                                        _0: /* List */0
                                      }
                                    });
                              }),
                            onItemCreated: (function (id) {
                                Buhta_cabinet__Route.navigateTo({
                                      TAG: /* Admin */7,
                                      _0: {
                                        TAG: /* Identities */2,
                                        _0: /* Item */{
                                          _0: id,
                                          _1: /* General */0
                                        }
                                      }
                                    });
                              })
                          }),
                      openMenu: openMenu,
                      arrowBack: true,
                      route: {
                        TAG: /* Admin */7,
                        _0: {
                          TAG: /* Identities */2,
                          _0: /* List */0
                        }
                      }
                    }) : JsxRuntime.jsx(AdminDashboardPage$DashboardContentWrapper, {
                      title: "Пользователи",
                      children: JsxRuntime.jsx(Buhta_cabinet__IdentitiesPage.make, {}),
                      rightChildren: JsxRuntime.jsx(AdminDashboardPage$NewIdentity, {}),
                      openMenu: openMenu
                    })
            ) : JsxRuntime.jsx(Buhta_cabinet__IdentityViewPage.make, {
                  route: match$4._1,
                  openMenu: openMenu
                });
          break;
      case /* Help */3 :
          const id$2 = route._0._0;
          tmp$1 = typeof id$2 === "number" ? (
              id$2 === /* List */0 ? JsxRuntime.jsx(Buhta_cabinet__HelpCenter.make, {}) : JsxRuntime.jsx(Buhta_cabinet__HelpNewTicketPage.make, {})
            ) : (
              id$2.TAG === /* View */0 ? JsxRuntime.jsx(Buhta_cabinet__HelpChatPage.make, {
                      id: id$2._0
                    }) : JsxRuntime.jsx(Buhta_cabinet__HelpCenter.make, {})
            );
          break;
      
    }
  }
  return JsxRuntime.jsx(Buhta_cabinet__Identity.Provider.make, Buhta_cabinet__Identity.Provider.makeProps([
                  match$3[0],
                  dispatch
                ], JsxRuntime.jsxs("div", {
                      children: [
                        tmp,
                        tmp$1
                      ],
                      className: "h-screen flex font-hauss"
                    }), undefined));
}

const make$1 = AdminDashboardPage;

export {
  DashboardContentWrapper ,
  NewOrg ,
  NewIdentity ,
  NewKey ,
  make$1 as make,
}
/* Buhta_cabinet__AdminDashboardHeader Not a pure module */
